import { render } from "./SettingsContainer.vue?vue&type=template&id=ead24fb8&scoped=true"
import script from "./SettingsContainer.vue?vue&type=script&lang=js"
export * from "./SettingsContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ead24fb8"

export default script